import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DomSanitizer, type SafeResourceUrl } from '@angular/platform-browser';
import { FLAT_SETTINGS, type SettingControlModel } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-matomo-stats',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './matomo-stats.component.html',
    styleUrls: ['./matomo-stats.component.scss'],
    standalone: false
})
export class MatomoStatsComponent {
  public safeUrl: SafeResourceUrl = '';
  
  constructor(
    private sanitizer: DomSanitizer,
    @Inject(FLAT_SETTINGS) public settings: SettingControlModel
  ) { 
    const { endpointUrl } = this.settings;
    const matomoUrl = `${endpointUrl}v2/matomo-stats`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(matomoUrl);
  }

}
